module.exports = __webpack_public_path__ + "img/17.c896cd61.jpg";